import { handleFormSubmit, useRequest } from '@polvo-labs/react-auth'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { load } from 'recaptcha-v3'
import Form from '../../components/Form'
import env from '../../config/env'
import fields, { ContactFormData } from './fields'

interface Props {

}

const ContactForm: React.FC<Props> = () => {
  const { request } = useRequest()
  const [recaptcha, setRecaptcha] = useState<any>(null)
  const recaptchaAction = 'Contact'
  const initialValues = {
    name: '',
    email: '',
    message: '',
    recaptcha: '',
    action: recaptchaAction,
  }
  const [reload, setReolad] = useState<any>(true)
  const recaptchaToken = env.captchaKey

  useEffect(() => {
    let mounted = true
    load(recaptchaToken, { autoHideBadge: true }).then((recaptcha: any) => {
      if (mounted)
        setRecaptcha(recaptcha)
    })
    return () => {
      mounted = false
    }
  }, [])

  return (
    (reload && <Form<ContactFormData>
      buttonLabel="ENVIAR MENSAGEM"
      fields={fields}
      initialValues={initialValues}
      onSubmit={async (data) => {
        const token = await recaptcha.execute(recaptchaAction)
        const dataSend = { ...data, recaptcha: token }
        return handleFormSubmit({
          request: request({
            method: 'POST',
            url: `${env.apiURL}/contact`,
            data: dataSend,
          }),
          onValidationErrors: () =>{
            toast.error('Erros de validacao.')
          },
          onSuccess: ({ data }) => {
            toast.success(data.message)
            setTimeout(() => {
              setReolad(false)
            }, 0)
            setTimeout(() => {
              setReolad(true)
            }, 1)
          },
          onFailure: (erro: any) => {
            toast.error(data.message)
            const errors = erro.toJSON()
            console.log(errors)
            if (errors.errors) {
              return errors
            }
          },
        })
      }}
    />)
  )
}

export default ContactForm
